import { render, staticRenderFns } from "./format.vue?vue&type=template&id=543feff4&scoped=true"
import script from "./format.vue?vue&type=script&lang=js"
export * from "./format.vue?vue&type=script&lang=js"
import style0 from "./format.vue?vue&type=style&index=0&id=543feff4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543feff4",
  null
  
)

export default component.exports